import { useEffect } from "react";
import { hideMenuTypeTabs, hideSchoolDrowdown, showMenuTypeTabs, showSchoolDrowdown } from "../../../../../actions/menuTypeAction";
import { useMenuTypeDispatch } from "../../../../../context/MenuTypeContext";
import { deleteVendorRecord, getActiveVendors, getVendorsData } from './../../../../../actions/vendorAction'
import { useState } from "react";
import { useAuthState } from "../../../../../context";
import { Card } from "react-bootstrap";
import { Badge, Button, CardBody, Col, Row, UncontrolledTooltip } from "reactstrap";
import RTable from './../../../../table';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { toast } from "react-toastify";
import confirmAlert from "../../../../conformAlert";

const Vendors = (props) => {
    const dispatch = useMenuTypeDispatch();
    const { otherInfo } = useAuthState();
    const [vendorRec, setVendorRec] = useState({});
    const [vendors, setVendors] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        hideMenuTypeTabs(dispatch);
        hideSchoolDrowdown(dispatch);
        return () => {
            showMenuTypeTabs(dispatch);
            showSchoolDrowdown(dispatch);
        }
    }, []);
    useEffect(() => {
        getVendors();
    }, []);

    const getVendors = async () => {
        setLoading(true);
        const res = await getVendorsData(otherInfo.catererId);
        setLoading(false);
        if (res.error) {
            setVendors([]);
        } else {
            setVendors(res.data || []);
        }
    }
    const getCols = () => {
        const cols = [{
            Header: 'Vendor Code',
            accessor: 'vendorCode',
            style: { width: '100px' },

        }, {
            Header: 'Vendor Name',
            accessor: 'name',

        },
        {
            Header: 'Email',
            accessor: 'email',
            style: { width: '250px' },
        }, {
            Header: 'Contact',
            accessor: 'contact',
            style: { width: '200px' },
            Cell: ({ row }) => {
                return <span>{`${row.original.contact}`}</span>
            }
        },
        {
            Header: 'Active Status',
            accessor: 'active',
            style: { width: '150px' },
            Cell: ({ row }) => {
                return <span>{row.original.active ? <Badge color={'success'}>Active</Badge> : <Badge>Inactive</Badge>}</span>
            }
        },
        {
            Header: 'Action',
            style: { width: '200px' },
            Cell: ({ row }) => {
            if (row.original.catererId === 0) {
             return (
               <>
                <Button
                    id={`viewButton-${row.original.id}`}
                    color="falcon-primary"
                    size="sm"
                    className="mr-1"
                    type="button"
                    onClick={() => {
                        props.history.push({
                            pathname: `/settings/vendorRec`,
                            state: {
                                data: row.original,
                                isdCode: otherInfo.isdCode
                            },
                        });
                    }}
                   >
                    <FontAwesomeIcon icon="eye" transform="shrink-3" className="mr-1" />
                    View
                </Button>
                <UncontrolledTooltip
                    placement="bottom"
                    target={`viewButton-${row.original.id}`}
                >
                    View Vendor
                </UncontrolledTooltip>
            </>
          );
         } else {
                return <>
                    <Button id={`editButton-${row.original.id}`} color="falcon-primary" size="sm" className='mr-1' type="button" onClick={(e) => {
                        props.history.push({
                            pathname: `/settings/vendorRec`, state: {
                                data: row.original,
                                isdCode: otherInfo.isdCode
                            },
                        });
                    }} >
                        <FontAwesomeIcon icon="pencil-alt" transform="shrink-3" /> Edit
                    </Button>
                    <UncontrolledTooltip
                        placement="bottom"
                        target={`editButton-${row.original.id}`}
                    >
                        Edit Vendor
                    </UncontrolledTooltip>
                    {/* <Button id={`deleteButton-${row.original.id}`} color="falcon-primary" size="sm" className='mr-1' type="button" onClick={async (e) => {
                        const confirmStatus = await confirmAlert({
                            title: 'Delete Confirmation',
                            message:
                                'Are you sure you want to delete this vendor?'
                        });
                        if (!confirmStatus) {
                            return false;
                        }
                        deleteVendor(row.original.id);

                    }} >
                        <FontAwesomeIcon icon="trash-alt" transform="shrink-3" /> Delete
                    </Button>
                    <UncontrolledTooltip
                        placement="bottom"
                        target={`deleteButton-${row.original.id}`}
                    >
                        Delete Storage Location
                    </UncontrolledTooltip> */}
                </>
            }
            }
        }
        ];
        return cols;

    }
    const deleteVendor = async (id) => {
        const res = await deleteVendorRecord(id);
        if (!res.error) {
            toast.success(res.data.message);
            getVendors();
        } else {
            toast.error(res.errorMessage);
        }

    }
    return (<>
        <Card className='shadow-none border mb-2 mt-2'>
            <CardBody className='py-2'>
                <Row>
                    <Col className='align-self-center'>
                        <h5 className='text-primary fw-bold mb-0'>Manage Vendors</h5>
                    </Col>
                    <Col className='d-flex justify-content-end'>
                        <Button color="falcon-primary" size="sm" onClick={(e) => {
                            props.history.push({
                                pathname: `/settings/vendorRec`, state: {
                                    data: {},
                                    isdCode: otherInfo.isdCode
                                }
                            });
                        }}>
                            <FontAwesomeIcon icon="plus" transform="shrink-3" className="mr-1" />
                            Add New Vendor
                        </Button>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12} className="mt-2">
                        <RTable loading={loading} columns={getCols()}
                            data={vendors} minRows="10" defaultPageSize={10} />
                    </Col>
                </Row>
            </CardBody>
        </Card>
    </>)
}
export default Vendors;